import { MockMethod } from 'vite-plugin-mock';
import { Random } from 'mockjs';
import { resultPageSuccess } from '../_util';

function getRandomPics(count = 10): string[] {
  const arr: string[] = [];
  for (let i = 0; i < count; i++) {
    arr.push(Random.image('800x600', Random.color(), Random.color(), Random.title()));
  }
  return arr;
}

const demoList = (() => {
  const result: any[] = [];
  for (let index = 0; index < 200; index++) {
    result.push({
      id: `${index}`,
      beginTime: '@datetime',
      endTime: '@datetime',
      address: '@city()',
      name: '@cname()',
      phonenumber: /^1[0-9]{10}$/,
      email: '#email()',
      name3: '@cname()',
      name4: '@cname()',
      name5: '@cname()',
      name6: '@cname()',
      name7: '@cname()',
      name8: '@cname()',
      remark: '@csentence()',
      idcard_no: '41273904943434993324',
      service_status: Math.ceil(Math.random() * (3 - 1) + 1),
      service_type: Math.ceil(Math.random() * (3 - 1) + 1),
      idcard_type: Math.ceil(Math.random() * (3 - 1) + 1),
      'idcardtype|1':['居民身份证', '军官证', '外籍人暂住证'],
      idcardno:'632323190605266929',
      basedPoints:'13800000000',
      canbaoplan:'@ctitle(5, 8)',
      sbcity:'@city()',
      gjjcity:'@city()',
      sbfeedback:'@ctitle(10, 20)',
      gjjfeedback:'@ctitle(10,20 )',
      'sbstatus|1':['待参保', '处理中', '已参保','已停保'],
      'gjjstatus|1':['待参保', '处理中', '已参保','已停保'],
      'types|1':['补缴', '补差'],
      'sbpaymentstatus|1':['待办理', '办理中','办理成功','办理失败'],
      'gjjpaymentstatus|1':['待办理', '办理中','办理成功','办理失败'],
      sbpaymentDate:'@date("yyyy-MM-dd")',
      gjjpaymentDate: '@date("yyyy-MM-dd")',
      reportname:'@ctitle(5, 8)',
      describe:'@ctitle(20, 30)',
      avatar: Random.image('400x400', Random.color(), Random.color(), Random.first()),
      imgArr: getRandomPics(Math.ceil(Math.random() * 3) + 1),
      imgs: getRandomPics(Math.ceil(Math.random() * 3) + 1),
      date: `@date('yyyy-MM-dd')`,
      time: `@time('HH:mm')`,
      createTime: `@date('yyyy-MM-dd')`,
      applyTime: `@time('HH:mm')`,
      'no|100000-10000000': 100000,
      'status|1': ['normal', 'enable', 'disable'],
      residencecitytatus: '北京',
      householdRegistration: '城镇',
      ofWorkstatus: '文员',
      rzdate: `@date('yyyy-MM-dd')`,
      sbjsstatus: "8000",
      gjjjsstatus: "7000",
      cbDate: `@date('yyyy-MM-dd')`,
      cbjzDate: `@date('yyyy-MM-dd')`,
      cbfastatus:"五险一金",
      'ygstatus|1':['待参保', '处理中', '已参保','已停保'],
      'event|1':['减员提醒','增员提醒','补缴补差提醒'],
      explain:'@ctitle(20, 30)',
      'open|1':['0', '1'],
      teminderTime:'每月'+Random.date('dd')+'号',
      title:'@ctitle(10, 12)',
      type:'@ctitle(5, 8)',
      'setType|1':['仅设置基数和比例','仅设置参保金额'],
      people:Random.integer(60, 100),
      cnum1:Random.integer(1000, 2000),
      cnum2:Random.integer(1000, 2000),
      cnum3:Random.integer(1000, 2000),
      cnum4:Random.integer(1000, 2000),
      monthDate:'@date("yyyy-MM")',
      'mxName|1':['待办理', '办理中','办理成功','办理失败'],

    }); 
  }
  return result;
})();

export default [
  {
    url: '/basic-api/table/getDemoList',
    timeout: 100,
    method: 'get',
    response: ({ query }) => {
      const { page = 1, pageSize = 20 } = query;
      return resultPageSuccess(page, pageSize, demoList);
    },
  },
] as MockMethod[];
